import { useEffect, useState } from 'react';
import { Category } from '../types';
import { apiService } from '../services/api';
import { CategoryForm } from './CategoryForm';

interface ImportCategorySelectProps {
  value: string;
  onChange: (categoriaId: string) => void;
}

export function ImportCategorySelect({ value, onChange }: ImportCategorySelectProps) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    apiService.getAllCategories().then(setCategories).catch(() => {});
  }, []);

  const handleCategoryCreated = async () => {
    setShowForm(false);
    try {
      const cats = await apiService.getAllCategories();
      setCategories(cats);
      const newest = [...cats].sort(
        (a, b) => new Date(b.criadoEm).getTime() - new Date(a.criadoEm).getTime()
      )[0];
      if (newest) onChange(newest.id);
    } catch {
      // ignora falha ao recarregar, usuário pode selecionar manualmente
    }
  };

  return (
    <div>
      <label htmlFor="import-categoria" className="block text-sm font-medium text-gray-700 mb-2">
        Categoria (opcional)
      </label>
      <div className="flex gap-2">
        <select
          id="import-categoria"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Sem categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.nome}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={() => setShowForm(true)}
          className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm font-medium whitespace-nowrap"
        >
          + Nova
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        Aplicada a todos os contatos desta importação (linhas com categoria própria mantêm a categoria informada).
      </p>

      {showForm && (
        <CategoryForm onSuccess={handleCategoryCreated} onCancel={() => setShowForm(false)} />
      )}
    </div>
  );
}
